var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.toc),function(item,index){return _c('li',{key:index,staticClass:"truncate"},[_c('a',{class:{
          'pl-2 mb-1 font-medium text-gray-700': item.element == 'h2',
          'pl-6 text-sm text-gray-600 mb-1': item.element == 'h3',
          'text-blue-600 border-l-2 border-blue-500 font-medium':
            item.value == _vm.firstSelected,
        },attrs:{"href":("#" + (item.value))}},[_vm._v(" "+_vm._s(item.value)+" ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }